import { getLocale } from 'lib/apiClient';
import { BrandCode, Locale } from 'lib/config/config';
import useSWR, { Fetcher } from 'swr';

function createCacheKey(locale: Locale): string {
	return `locale-${locale.country}-${locale.language}`;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function useLocale(locale: Locale, brand: BrandCode) {
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	const fetcher: Fetcher<any, string> = async () => {
		if (!locale.office || !locale.market) return getLocale(locale.country, locale.language, brand);
		else return Promise.resolve(locale);
	};

	return useSWR(createCacheKey(locale), fetcher, { fallbackData: locale });
}
